/**
 * Legal disclaimer component for email subscription consent.
 * GDPR/CAN-SPAM compliant: clearly states subscription intent,
 * includes unsubscribe mention, and links to privacy policy.
 */
export function EmailConsentText() {
  return (
    <div className="relative">
      {/* Decorative accent line */}
      <div className="absolute -left-4 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-border to-transparent" />

      <p className="text-xs leading-relaxed text-muted-foreground pl-2">
        By continuing, you agree to subscribe to the{" "}
        <span className="font-medium text-foreground/80">
          irreplaceable.engineer
        </span>{" "}
        mailing list and receive educational content and updates. You can
        unsubscribe at any time via the link in any email.
      </p>
    </div>
  );
}
